import {
  Map, Route, Sparkles, Heart, Footprints, Camera, Download, Layers, Lock, Cloud, Shield,
  Compass, MousePointerClick,
} from "lucide-react";

const ICONS = {
  map: Map, route: Route, sparkles: Sparkles, heart: Heart, footprints: Footprints,
  camera: Camera, download: Download, layers: Layers, lock: Lock, cloud: Cloud,
  shield: Shield, compass: Compass, default: MousePointerClick,
};

export function FeatureIcon({ name, className }) {
  const Cmp = ICONS[name] || ICONS.default;
  return <Cmp className={className} />;
}
